var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "add-item-to-basket-overlay" } }, [
    _c("div", { staticClass: "modal fade" }, [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _vm.basketItem
          ? _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title h5" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.singleItemAdded")
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row is-table-row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-md-4",
                        staticStyle: { "min-height": "80px" },
                      },
                      [
                        _c("img", {
                          directives: [
                            { name: "lazyload-img", rawName: "v-lazyload-img" },
                          ],
                          staticClass: "img-fluid mx-auto",
                          staticStyle: { "max-height": "140px" },
                          attrs: {
                            "data-src": _vm.imageUrl,
                            alt: _vm.imageAlternativeText || _vm.itemName,
                            title: _vm.itemName,
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-8" },
                      [
                        _c("p", [
                          _c("strong", [_vm._v(_vm._s(_vm.itemName))]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.countAdditionalBasketItems > 0
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.basketItemOverlayAdditionalCount",
                                      { count: _vm.countAdditionalBasketItems }
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "small" }, [
                          _c("strong", [
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.basketItem.quantity) + " x "),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("currency")(_vm.price))),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.variation.attributes, function (attribute) {
                          return _c(
                            "p",
                            { key: attribute, staticClass: "small" },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(attribute.attribute.names.name)),
                              ]),
                              _vm._v(":\n                "),
                              _c("span", [
                                _vm._v(_vm._s(attribute.value.names.name)),
                              ]),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.shownOrderProperties.length
                          ? _c("div", { staticClass: "small" }, [
                              _c(
                                "div",
                                { staticClass: "font-weight-bold my-1" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemAdditionalOptions"
                                        )
                                      ) +
                                      ":\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "ml-1 pl-3" },
                                _vm._l(
                                  _vm.shownOrderProperties,
                                  function (property) {
                                    return _c(
                                      "li",
                                      { key: property.propertyId },
                                      [
                                        _c("span", { staticClass: "d-block" }, [
                                          _c(
                                            "strong",
                                            {
                                              class: {
                                                colon: property.type.length > 0,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(property.name) +
                                                  "\n                        (" +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemIncludeAbbr"
                                                    )
                                                  ) +
                                                  "\n                        " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      _vm._f(
                                                        "propertySurcharge"
                                                      )(
                                                        _vm.basketItem.variation
                                                          .data.properties,
                                                        property.propertyId
                                                      )
                                                    )
                                                  ) +
                                                  ")\n                      "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            [
                                              _c("order-property-value", {
                                                attrs: { property: property },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-outline-primary btn-medium mr-2",
                      attrs: { href: _vm.urls.basket, rel: "nofollow" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "margin-right": "5px",
                            width: "16px",
                            height: "16px",
                          },
                          attrs: {
                            width: "17",
                            height: "19",
                            viewBox: "0 0 17 19",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M2.80434 7.65586C2.83273 7.30219 2.99329 6.97215 3.25406 6.73153C3.51482 6.49091 3.85666 6.35731 4.21148 6.35742H12.7206C13.0754 6.35731 13.4173 6.49091 13.6781 6.73153C13.9388 6.97215 14.0994 7.30219 14.1278 7.65586L14.6944 14.7127C14.71 14.9069 14.6852 15.1022 14.6216 15.2864C14.558 15.4705 14.4569 15.6395 14.3248 15.7827C14.1927 15.9259 14.0324 16.0401 13.8539 16.1184C13.6755 16.1965 13.4828 16.2369 13.288 16.237H3.6441C3.44928 16.2369 3.25658 16.1965 3.07813 16.1184C2.89969 16.0401 2.73936 15.9259 2.60724 15.7827C2.47513 15.6395 2.37409 15.4705 2.31048 15.2864C2.24688 15.1022 2.22209 14.9069 2.23768 14.7127L2.80434 7.65586Z",
                              stroke: "white",
                              "stroke-width": "1.95171",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M11.2898 8.47322V4.94481C11.2898 4.19617 10.9924 3.4782 10.463 2.94883C9.93361 2.41947 9.21564 2.12207 8.46702 2.12207C7.71839 2.12207 7.00042 2.41947 6.47105 2.94883C5.94168 3.4782 5.64429 4.19617 5.64429 4.94481V8.47322",
                              stroke: "white",
                              "stroke-width": "1.95171",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemBasket")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-primary btn-medium",
                      attrs: { href: _vm.urls.checkout, rel: "nofollow" },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-arrow-right",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.singleItemCheckout")
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm._t("extendOverlayButtons"),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "text-muted ml-auto" }, [
      _c("span", { staticClass: "timer" }),
      _vm._v("s"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close ml-0 pl-1",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }